import { render, staticRenderFns } from "./events-list.vue?vue&type=template&id=530b52eb&"
import script from "./events-list.vue?vue&type=script&lang=js&"
export * from "./events-list.vue?vue&type=script&lang=js&"
import style0 from "./events-list.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/events/components/events-list/events-list.vue
// module id = 1171
// module chunks = 0